module.exports = __webpack_public_path__ + "img/ipc_materials.f124b884.png";